import { createSnapshotValue as createMutable } from '../../lib/snapshot-value.ts'
import { ROUTE_TEMPLATE, type StageKey } from './catalog.ts'
import type { ProtoFile } from './orders.ts'
import type { BomLine } from './warehouse.ts'

/**
 * Spec §12.7: a технологічна карта is versioned. A draft can change; approving it freezes a new
 * version and becomes the one new manufacturing orders use. Orders already running keep the
 * version they were released with, so a later edit never rewrites the shop's history.
 */
export type TechCardStatus = 'draft' | 'released' | 'archived'

export const TECH_CARD_STATUS: Record<TechCardStatus, string> = {
  draft: 'Чернетка',
  released: 'Чинна',
  archived: 'Архів',
}

export interface TechCardVersion {
  productId: string
  version: number
  status: TechCardStatus
  route: StageKey[]
  bom: BomLine[]
  instructions: string
  media: ProtoFile[]
  /** Drawings and other files of the card. Older cards may not have the list. */
  files?: ProtoFile[]
  /** What changed and why, written by whoever approves it. */
  note: string | null
  createdAt: string
  createdById: string
  releasedAt: string | null
  releasedById: string | null
}

/** Operations a BOM line can point at: the route stages plus the bench work that has no stage. */
export const OPERATIONS = createMutable([] as string[])

export const operationOptions = (current: string[] = []) => [
  ...new Set([
    ...ROUTE_TEMPLATE.filter((stage) => !stage.archived || current.includes(stage.label)).map(
      (stage) => stage.label,
    ),
    ...OPERATIONS,
    ...current,
  ]),
]
